import GroupBy from "@/components/GroupBy.vue";
import LoadingElement from "@/components/shared/LoadingElement.vue";
import { mapState } from "vuex";
export default {
  name: "ProductTableGroupBy",
  components: {
    GroupBy,
    LoadingElement
  },
  emits: ["refresh", "clicked"],
  props: {
    tabBusy: {
      type: Boolean
    }
  },
  computed: {
    ...mapState({
      groupByElements: state => state.dsp_report.product_table.group_by_elements
    }),
    groupByIndex: {
      get() {
        console.log(this.groupByElements);
        return this.$store.getters.dspGetProductTableGroupBy();
      },
      set(val) {
        this.$store.dispatch("dspSetProductTableGroupBy", val);
        this.$emit("refresh");
      }
    }
  },
  methods: {
    handleClicked() {
      this.$emit('clicked');
    }
  }
};